import actionTypes from '../constants/action-types';

const emptyPage = (state = {}, action) => {
  if (action.type !== actionTypes.SET_EMPTY_PAGE) return state;

  return action.payload.emptyPage;
};

export default emptyPage;
